import { useNavigate } from 'react-router';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Stack
      spacing={2}
      sx={{ minHeight: '100dvh', justifyContent: 'center', alignItems: 'center', textAlign: 'center', px: 3 }}
    >
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        That screen does not exist
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '40ch' }}>
        The link may be out of date, or the screen may land in a later phase. Use the sidebar to
        get back.
      </Typography>
      <Button variant="contained" onClick={() => void navigate('/', { replace: true })}>
        Back to the dashboard
      </Button>
    </Stack>
  );
}
